import { User } from "../models/User"
import { UserCreation } from "../models/UserCreation"
import api from "../api"

const API_BASE = process.env.REACT_APP_API_URL || '/'

export class UserService {
    private static async handleResponse<T>(response: Response): Promise<T> {
        if (!response.ok) throw new Error(await response.text() || "Erreur inconnue")
        return response.json()
    }

    static async getUsers(): Promise<User[]> {
        const { data, status } = await api.get("/users")
        if (status !== 200) throw new Error("Impossible de récupérer les utilisateurs")
        return data as User[]
    }

    static async getCurrentUser(): Promise<User> {
        const { data, status } = await api.get("/users/me")
        if (status !== 200) throw new Error("Impossible de récupérer l'utilisateur courant")
        return data as User
    }

    static async createUser(userData: Partial<UserCreation>): Promise<User> {
        const res = await fetch(`${API_BASE}/auth/signup`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(userData),
        })
        return this.handleResponse<User>(res)
    }

    static async updateUser(userId: number, userData: Partial<User>): Promise<User> {
        const res = await api.put(`/users/${userId}`, userData)
        if (res.status !== 200) throw new Error("Erreur lors de la mise à jour de l'utilisateur")
        return res.data as User
    }

    static async deleteUser(userId: number): Promise<void> {
        const res = await api.delete(`users/${userId}`)
        if (res.status !== 200) throw new Error("Erreur lors de la suppression de l'utilisateur")
    }

    static async deleteCurrentUser(): Promise<void> {
        const res = await api.delete(`users/me`)
        if (res.status !== 200) throw new Error("Erreur lors de la suppression de l'utilisateur courant")
    }

    static async login(email: string, password: string): Promise<void> {
        const res = await fetch(`${API_BASE}/auth/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        })
        const data = await this.handleResponse<{ token: string }>(res)
        localStorage.setItem("token", data.token)
    }

    static async logout(): Promise<void> {
        localStorage.removeItem("token")
    }

    static async updateCurrentUser(userData: Partial<User>): Promise<User> {
        const res = await api.put(`/users/me`, userData)
        if (res.status !== 200) throw new Error("Erreur lors de la mise à jour de l'utilisateur courant")
        return res.data as User
    }

    static async getUsersByIds(userIds: number[]): Promise<User[]> {
        const res = await api.post(`/users/ids`, userIds)
        if (res.status !== 200) throw new Error("Erreur lors de la récupération des utilisateurs par leurs IDs")
        return res.data as User[]
    }
}
